// $(document).ready(function () {
//   const cartDrawer = document.querySelector('cart-drawer');
//   const cartNotification = document.querySelector('.cartNotificationCstm').querySelector('.sucessmsg');

//   $('.btn_hover .add_tocart').click(function (e) {
//     // alert();
//     e.preventDefault();
//     var var_id = $(this).attr('var_id');
//     console.log("var_id>>>", var_id);

//     const config = fetchConfig('javascript');
//     config.headers['X-Requested-With'] = 'XMLHttpRequest';
//     delete config.headers['Content-Type'];

//     var formData = new FormData();
//   var formData = new FormData();
// formData.append('items[0][id]', var_id);
// formData.append('items[0][quantity]', 1);

//     if (cartDrawer) {
//       formData.append(
//         'sections',
//         cartDrawer.getSectionsToRender().map((section) => section.id).join(',')
//       );
//       formData.append('sections_url', window.location.pathname);
//       cartDrawer.setActiveElement(document.activeElement);
//     }

//     config.body = formData;

//     fetch(`${routes.cart_add_url}`, config)
//       .then((response) => response.json())
//       .then((response) => {
//         console.log("response>>>", response);
//         //    cartNotification.style.display = 'block';
//         // setTimeout(function(){
//         //    cartNotification.style.display = 'none';
//         // },1e3);
//            // cartDrawer.renderContents(response);
//             // console.log(" cartDrawer.renderContents(response);>>>", cartDrawer.renderContents(response));
//         if (response.status) {
//           publish(PUB_SUB_EVENTS.cartError, {
//             source: 'product-form',
//             productVariantId: formData.get('id'),
//             errors: response.errors || response.description,
//             message: response.message,
//           });
//             cartNotification.style.display = 'block';
//            cartDrawer.renderContents(response);
//             // console.log(" cartDrawer.renderContents(response);>>>", cartDrawer.renderContents(response));
//           return;
//         } else if (!cartDrawer) {
//           window.location = window.routes.cart_url;
//           console.log("submitButton>>>");
//           return;
//         }

//         if (response.status) {
//           publish(PUB_SUB_EVENTS.cartUpdate, {
//             source: 'product-form',
//             productVariantId: formData.get('id'),
//             cartData: response,
//           });

//           console.log("submitButton2>>>");
//           // Code for ATC notification
//           cartNotification.style.display = 'block';
//            cartDrawer.renderContents(response);
//           console.log(" cartDrawer.renderContents(response);>>>", cartDrawer.renderContents(response));
//         }
//       })
//       .catch((e) => {
//         console.error(e);
//       })
//       .finally(() => {
//         console.log("finallyyyy");
//         // Handle loading and styling if needed
//         // this.submitButton.classList.remove('loading');
//         if (cartDrawer && cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
//         // if (!this.error) this.submitButton.removeAttribute('aria-disabled');
//         // this.querySelector('.loading__spinner').classList.add('hidden');
//       });
//   });
// });
  $(document).ready(function() {
        $(window).scroll(function() {  
            var scroll = $(window).scrollTop();
            if (scroll >= 10) {
                $("body").addClass("whiteHeader");
            } else {
                $("body").removeClass("whiteHeader");
            }
        });
    });